export default "\n.n-dropdown-menu {\r\n  max-height: 250px;\r\n  overflow-y: auto;\n}\r\n"